import React from 'react';
import { remCalc } from 'util/style-util';
import { getTranslatedImage } from 'translations/translator';
import closeX from 'assets/images/close-x.png';
import Overlay from 'components/@common/ScreenOverlay';
import { makeStyles } from '@mui/styles';

type Props = {
  toggleOnboardingNavigationMenuOverlay: () => void;
  imageUrl: string;
};

const SlideoutMenuTutorial = (props: Props) => {
  const { toggleOnboardingNavigationMenuOverlay } = props;
  const { slideoutTutorial, clickToCloseCSS, closeXCSS } = useStyles();
  const dismissOverlay = () => toggleOnboardingNavigationMenuOverlay();

  return (
    <Overlay zIndex={12} show={true} classList={[]}>
      <img src={closeX} className={closeXCSS} alt="X" onClick={dismissOverlay} />
      <img
        src={getTranslatedImage('click-to-close.png')}
        className={clickToCloseCSS}
        alt="clickToClose"
        onClick={dismissOverlay}
      />
      <img src={props.imageUrl} className={slideoutTutorial} alt="tutorialMenu" />
    </Overlay>
  );
};

const useStyles = makeStyles(() => ({
  slideoutTutorial: {
    backgroundSize: 'cover',
    zIndex: 11,
    position: 'absolute',
    left: 0,
    top: 0,
    flexFlow: 'column nowrap'
  },
  clickToCloseCSS: {
    position: 'absolute',
    marginTop: remCalc(100),
    marginLeft: remCalc(275),
    top: '30%',
    left: '60%',
    zIndex: 12,
    cursor: 'pointer'
  },
  closeXCSS: {
    position: 'absolute',
    height: remCalc(40),
    width: remCalc(40),
    top: '1%',
    right: '1%',
    zIndex: 12,
    cursor: 'pointer'
  }
}));

export default SlideoutMenuTutorial;
